import { __assign, __awaiter, __generator } from "tslib";
import { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import useLoadingButton from './useLoadingButton';
var useFormUpdate = function (initialState, validationSchema, callback) {
    if (callback === void 0) { callback = function () {
        return undefined;
    }; }
    var _a = useLoadingButton(), isLoading = _a[0], setButtonLoading = _a[1];
    var _b = useState(false), isEnabled = _b[0], setIsEnabled = _b[1];
    var _c = useReducer(function (state, newState) { return (__assign(__assign({}, state), newState)); }, initialState), formData = _c[0], setFormData = _c[1];
    var _d = useReducer(function (state, newState) {
        if (newState === null) {
            return {};
        }
        else {
            return __assign(__assign({}, state), newState);
        }
    }, {}), updatedData = _d[0], setUpdatedData = _d[1];
    var isStateValid = useMemo(function () {
        return Object.keys(validationSchema).some(function (key) {
            var k = key;
            var isRequired = validationSchema[k].required;
            try {
                var _a = formData[k], value = _a.value, error = _a.error;
                return (isRequired && !value) || error;
            }
            catch (_b) {
                return false;
            }
        });
    }, [formData, validationSchema]);
    useEffect(function () {
        setIsEnabled(!isStateValid);
    }, [isStateValid, setIsEnabled]);
    var handleUpdateData = useCallback(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var name, value, id, _a, isRequired, equalsField, validator, isValueString, updatedDataPayload, error, formDataPayload_1, formDataPayload;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            name = payload.name, value = payload.value, id = payload.id;
            _a = validationSchema[name], isRequired = _a.required, equalsField = _a.equalsField, validator = _a.validator;
            isValueString = typeof value === 'string';
            updatedDataPayload = (_b = {}, _b[name] = value, _b);
            error = '';
            if (isRequired && !value) {
                error = 'required';
            }
            if (!validator && equalsField) {
                if (value !== formData[equalsField.field].value) {
                    error = equalsField.error;
                }
                formDataPayload_1 = (_c = {}, _c[name] = { value: value, error: error, id: id }, _c);
                setFormData(formDataPayload_1);
                setUpdatedData(updatedDataPayload);
            }
            if (validator) {
                if (isValueString && !validator.regEx.test(value)) {
                    error = validator.error;
                }
            }
            formDataPayload = (_d = {}, _d[name] = { value: value, error: error, id: id }, _d);
            setFormData(formDataPayload);
            setUpdatedData(updatedDataPayload);
            return [2 /*return*/];
        });
    }); }, [validationSchema, formData]);
    var handleOnSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setButtonLoading(true);
                    if (!!isStateValid) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, callback(updatedData, formData)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.warn('Form submit error', error_1);
                    return [3 /*break*/, 4];
                case 4:
                    setButtonLoading(false);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [setButtonLoading, isStateValid, callback, updatedData, formData]);
    var resetData = useCallback(function () {
        setFormData(initialState);
        setUpdatedData(null);
    }, [initialState]);
    return {
        formData: formData,
        updatedData: updatedData,
        handleUpdateData: handleUpdateData,
        isEnabled: isEnabled,
        handleOnSubmit: handleOnSubmit,
        isLoading: isLoading,
        resetData: resetData
    };
};
export default useFormUpdate;
//# sourceMappingURL=useFormUpdate.js.map